<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["message"])
  },
  watch: {
    message: function() {
      this.$bvToast.toast(this.message.content, {
        title: this.message.done,
        variant: this.message.variant,
        toaster: "b-toaster-bottom-right",
        solid: true,
        autoHideDelay: 2000,
        appendToast: true
      });
    }
  }
};
</script>